import { useWidgets } from "../../../hooks/useProvideWidgets";
import widgetsList from "../../../widgets";
import { InputRenderer } from "../../InputRenderer";

export const Tts = () => {
  const {
    widgets,
    selectedWidgetId,
    targetWidget,
    activeSection,
    selectedVariation,
  } = useWidgets();

  const renderVariables = () => {
    if (!targetWidget) {
      return;
    }

    const hasSubSections = targetWidget?.hasSubSettings;

    const { tts } =
      (hasSubSections
        ? typeof selectedVariation !== "undefined"
          ? targetWidget?.variables[activeSection]?.variations[
              selectedVariation
            ]?.settings
          : targetWidget?.variables[activeSection]
        : targetWidget) || {};

    if (typeof tts === "undefined") {
      return;
    }

    const ttsKeys = Object.keys(tts);

    return (
      <div className="grid gap-6">
        {ttsKeys.map((key) => {
          if (!key) {
            return;
          }
          const widgetType = targetWidget?.type;
          const fields = !hasSubSections
            ? widgetsList[widgetType]?.fields
            : widgetsList[widgetType]?.fields["tts"];
          const targetField = fields[key];
          const value = tts[key];

          return (
            <>
              <InputRenderer
                section={
                  hasSubSections ? `variables.${activeSection}.tts` : "tts"
                }
                key={key}
                variableKey={key}
                value={value}
                field={targetField}
                widgetId={selectedWidgetId}
              />
            </>
          );
        })}
      </div>
    );
  };

  return (
    <div>{targetWidget && targetWidget?.variables && renderVariables()}</div>
  );
};
